var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23023 31.15C5.37361 31.15 4.64055 30.8452 4.03104 30.2357C3.42154 29.6262 3.11627 28.8926 3.11523 28.035V9.34498C3.11523 8.48836 3.4205 7.75529 4.03104 7.14579C4.64158 6.53629 5.37465 6.23102 6.23023 6.22998H31.1502C32.0069 6.22998 32.7404 6.53525 33.351 7.14579C33.9615 7.75633 34.2663 8.48939 34.2652 9.34498V28.035C34.2652 28.8916 33.9605 29.6252 33.351 30.2357C32.7415 30.8463 32.0079 31.151 31.1502 31.15H6.23023ZM18.6902 20.2475L31.1502 12.46V9.34498L18.6902 17.1325L6.23023 9.34498V12.46L18.6902 20.2475Z",
    fill: "#1E3240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1ac5d14bd58707baea36d166d18f7334.svg";
export { ForwardRef as ReactComponent };